import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as rxjs from 'rxjs'

import * as assistant from '../../../../assistant'
import { Collection } from '../../collection'

import * as gql from './gql'

@ngCore.Injectable({ providedIn: 'root' })
export class Api implements assistant.oneOff.Api {
  /** @see {@link orgChart.Feature} */
  private readonly _ec = ngCore.inject(Collection)

  /**
   * @see {@link gql.mutations.askAboutOrgChart.execute}
   */
  public ask: assistant.oneOff.Api['ask'] = (
    { tenantId, zoneId },
    { question },
  ) => {
    const archive =
      this._ec.plugins.currentEntityPlugin.feature.selectors
        .getEditedEntity()
        .asSignal() ??
      this._ec.plugins.currentEntityPlugin.feature.selectors
        .getEntity()
        .asSignal()
    return archive && ents.core.summit.Archive.isArchive(archive)
      ? gql.mutations.summarizeArchive.execute({
          archive: {
            description: archive.description,
            employees: archive.employees,
            instructions: archive.instructions,
            name: archive.name,
          },
          tenantId,
          zoneId,
        })
      : rxjs.of({ replies: [] })
  }
}
